import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { FieldArray } from "formik";
import { FormikProps, FormikValues, useFormikContext } from "formik";
import { Add } from "@mui/icons-material";
import { IconMinus } from "@tabler/icons";
import { InputField } from "../../../../utils/FormFields";
import { FileBodyTypeEnum } from "../../../../api/file-management";
import UploadField from "../../../../utils/FormFields/UploadField";


const ResultsDocuments = () => {
  const formik: FormikProps<FormikValues> = useFormikContext();

  return (
    <>
      <FieldArray
        name="ResultsDocuments"
        render={(arrayHelpers) => (
          <>
            <Tooltip title="Add Result Documents">
              <Button
                onClick={() => {
                  arrayHelpers.push("");
                }}
                color="primary"
                variant="outlined"
                sx={{ p: 1, mb: 2, mt: 1 }}
              >
                <Add /> Add Test Result
              </Button>
            </Tooltip>
            <Grid container spacing={3}>
              {formik?.values?.ResultsDocuments.map((result: string, index: number) => (
                <>
                  <Grid item xs={12} sm={5} md={3.5} key={"URI" + index}>
                    <UploadField
                      name={`ResultsDocuments[${index}].URI`}
                      label={"Test Result " + (index + 1) +" (PDF/Image)"}
                      fileType={FileBodyTypeEnum.TESTRESULTIMAGE}
                    />
                  </Grid>
                  <Grid item xs={12} sm={11} md={3.5} key={"Description" + index}>
                    <InputField
                      name={`ResultsDocuments[${index}].Description`}
                      label="Description"
                      multiline
                      rows={1}
                      fullWidth
                      variant="filled"
                    />
                  </Grid>
                  <Grid item xs={12} sm={11} md={3.5} key={"Category" + index}>
                    <InputField
                      name={`ResultsDocuments[${index}].ImageCategory`}
                      label="Category"                      
                      rows={1}
                      fullWidth
                      variant="filled"
                    />
                  </Grid>
                  <Grid item xs={4} sm={0.5} md={0.5}>
                    <Tooltip title="Delete">
                      <IconButton onClick={() => arrayHelpers.remove(index)}>
                        <IconMinus color="red" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </>
              ))}
            </Grid>
          </>
        )}
      />
    </>
  );
};

export default ResultsDocuments;
